// @flow
import { createSelector } from 'reselect';
import { urlCatalog } from 'angieslist-app-platform';
import { get } from 'lodash';

export type AccountOwnerDetailsType = {
  name: string,
  email: string,
  phone: string,
  isDefault: boolean,
}

const getServiceProviderId = state => state.serviceProviderId;
const getServiceProviderCache = state => state.serviceProviderCache;

export const getAccountOwnerDetails: (state: any) => AccountOwnerDetailsType = createSelector(
  [getServiceProviderId, getServiceProviderCache],
  (serviceProviderId, serviceProviderCache) => {
    const angiBusinessCenter = 'Angi Business Center';
    const repDetails = get(serviceProviderCache, `${serviceProviderId}.accountOwner`, {});

    const name = get(repDetails, 'name', angiBusinessCenter);
    const email = get(repDetails, 'email', urlCatalog.global.businessCenterEmail());
    const phone = get(repDetails, 'phone', urlCatalog.global.businessCenterPhoneText());
    const isDefault = name === angiBusinessCenter;

    const accountOwnerDetails: AccountOwnerDetailsType = {
      email,
      name,
      phone,
      isDefault,
    };

    return accountOwnerDetails;
  },
);

export default {
  getAccountOwnerDetails,
};



// WEBPACK FOOTER //
// ./src/modules/home/common/selectors/accountOwnerSelectors.js